import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { AppState } from '@client/common/redux/store';
import {
  fetchProductVariantsMatrix,
  selectProductVariantsMatrixBySku,
} from '@client/product/redux/productVariantsMatrix/redux';
import { ProductVariantsMatrixType } from '@client/product/redux/productVariantsMatrix/types';

export const useProductVariantsMatrixEffect = (
  sku: string,
): RemoteRecord<ProductVariantsMatrixType> => {
  const dispatch = useDispatch();
  const variantsMatrix = useSelector((state: AppState) => selectProductVariantsMatrixBySku(state, sku));

  useEffect((): void => {
    if (!variantsMatrix.wasStarted) {
      dispatch(fetchProductVariantsMatrix({ sku }));
    }
  }, [variantsMatrix.wasStarted, sku]);

  return variantsMatrix;
};
